<template>
  <div class="talent-item-time-line">
    <div class="item-time-line-content" v-if="resData.wanted_post">
      <img :src="require('$img/time-radio.png')" alt="" width="13px" height="13px">
      <span>意向：</span>
      <label v-for="(post,index) in resData.wanted_post" :key="index" >
        <label :class="filterRef.kw && post.indexOf(filterRef.kw) !== -1?'red':''">{{post}}</label>{{(index !== (resData.wanted_post.length-1)) ? '、':''}}
      </label>
      <div class="border"></div>
    </div>
    <div class="item-time-line-content">
      <img :src="require('$img/time-radio.png')" alt="" width="13px" height="13px">
      <span>院校：</span>{{resData.education||''}} · <label :class="filterRef.kw && resData.school && resData.school.indexOf(filterRef.kw) !== -1?'red':''">{{resData.school||''}}</label> · <label :class="filterRef.kw && resData.major && resData.major.indexOf(filterRef.kw) !== -1?'red':''">{{resData.major||''}}</label>
      <div class="border" v-if="resData.recent_post"></div>
    </div>
    <div class="item-time-line-content" v-if="resData.recent_post">
      <img :src="require('$img/time-radio.png')" alt="" width="13px" height="13px">
      <span>曾任：</span>
      <label :class="filterRef.kw && resData.recent_post && resData.recent_post.indexOf(filterRef.kw) !== -1?'red':''">{{resData.recent_post}}</label> · 
      <label :class="filterRef.kw && resData.recent_project && resData.recent_project.indexOf(filterRef.kw) !== -1?'red':''">{{resData.recent_project}}</label>{{filterRef.kw && resData.recent_project && resData.recent_company?'/':''}}<label :class="filterRef.kw && resData.recent_company && resData.recent_company.indexOf(filterRef.kw) !== -1?'red':''">{{resData.recent_company}}</label>
      <!-- {{resData.recent_post}} · {{resData.recent_project?resData.recent_project:''}}{{resData.recent_project?'/'+resData.recent_company:resData.recent_company}} -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['resData','filterRef'],
  created(){

  }
}
</script>

<style lang='scss'>
@import '$styles/global.scss';

.talent-item-time-line{
  height: 100%;
  .item-time-line-content{
    margin-top: 21px;
    color: #3C4554;
    font-size: 14px;
    position: relative;
    img{
      margin-right: 10px;
    }
    span{
      color: #888D96;
    }
    .border{
      height: 26px;
      background-color: #D8D8D8;
      position: absolute;
      left: 5.8px;
      top: 15.5px;
      width: 1px;
    }
    .red{
      color: red;
    }
  }
  .item-time-line-content:first-child{
    margin-top: 0;    
  }
  .time-item:last-child{
    .ti-line{
      height: 0;
    }
  }

  // .time-item{

  //   .ti-content{

  //     img{
  //       width: 13px;
  //       height: 13px;
  //     }

  //     .tic-name{
  //       font-size: 14px;
  //       margin-left: 22px;
  //     }

  //     .one-line{
  //       @include flex-box(flex-start);

  //       .o-l-time{
  //         color: #888D96;
  //         font-size: 12px;
  //         padding-left: 17px;
  //       }
  //     }

  //     .two-line{
  //       margin-left: 6px;
  //       padding-top: 2px;
  //       border-left: 1px solid #D8D8D8;
  //       @include flex-box(flex-start);
  //     }
  //   }

  //   .ti-tag-item{
  //     margin-left: 20px;
  //     @include flex-box(flex-start);

  //     .tti-box{
  //       border-radius: 4px;
  //       background-color: #F7AD59;
  //       padding: 3px 12px;
  //       margin-right: 10px;
  //       font-size: 12px;
  //       color: #FFF;
  //     }
  //   }

  //   .ti-line{
  //     height: 8px;
  //     margin-left: 6px;
  //     width: 1px;
  //     background-color: #D8D8D8;
  //   }
  // }

}
</style>
